import React, { ReactElement, useState } from 'react'
import { ISelect } from '../../interfaces/FormFields'
import { ALERT_MESSAGES } from '../../enums/common'
import StyledSelect from './StyledSelect'

const MySelect = ({
  onChange,
  error,
  options,
  value,
  register,
  placeHolder,
  label,
  labelBold,
  id,
  className = '',
  required,
  resetSelectWithId,
  ...rest
}: ISelect): ReactElement => {
  const isPlaceholderDefaultSelected = placeHolder || !options[0].value
  const [reaccesSelectedOption, setReaccesSelectedOption] = useState({
    label: placeHolder || options[0].label,
    index: 0,
    isPlaceholder: !!isPlaceholderDefaultSelected,
  })
  const handleReacces = (selectId: string, placeHolderReaccess: string) => {
    const select = document.getElementById(selectId) as HTMLSelectElement
    const optionSelected = select.childNodes[
      select.selectedIndex
    ] as HTMLOptionElement
    if (optionSelected) {
      setReaccesSelectedOption({
        label: optionSelected.innerText,
        index: optionSelected.index,
        isPlaceholder: optionSelected.innerText === placeHolderReaccess,
      })
    }
  }

  return (
    <div className={`inputGroup ${className}`}>
      {label && (
        <label
          className={`inputLabel ${labelBold ? 'fontWeight700' : ''}`}
          htmlFor={id}
        >
          <span className={required ? 'inputLabelRequired' : ''}>{label}</span>
        </label>
      )}
      <div className="inputSelectWrapper">
        <select
          {...rest}
          id={id}
          className="hidden"
          ref={register}
          onChange={(e) => {
            if (onChange) {
              onChange(e)
            }
            handleReacces(id, placeHolder || options[0].label)
          }}
          defaultValue={value}
        >
          {placeHolder && (
            <option selected value="">
              {placeHolder}
            </option>
          )}
          {options.map((option) => (
            <option
              id={`${option.value + id}option`}
              key={option.value + id}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
        <StyledSelect
          error={error}
          options={options}
          placeHolder={placeHolder}
          id={id}
          reaccesSelectedOption={reaccesSelectedOption}
          updateReacessSelectedOption={setReaccesSelectedOption}
          resetSelectWithId={resetSelectWithId}
        />
        <div className="inputSelectIcon" />
      </div>
      {error && (
        <p className="fontSizeXs textDanger mt05">
          {error.message || ALERT_MESSAGES.mandatory.message}
        </p>
      )}
    </div>
  )
}

export default MySelect
